import { MonitorAppsComponent } from './monitor-apps/monitor-apps.js';

if (!customElements.get('monitor-apps')) {
  window.customElements.define('monitor-apps', MonitorAppsComponent);  
}